import React from 'react'
import top from '../assets/top.png'
import doc from '../assets/sup.png'
import r1 from '../assets/r1.png'
import p2 from '../assets/fam.png'
import p3 from '../assets/p3.png'


const  Hero = () => {

  const up = () => {
     window.scrollTo({
      top: 600,
      left: 0,
      behavior: 'smooth' 
    });
}

  return (
    <>
      <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-20">
            <div class="relative @container">
            <div class="flex min-h-[520px] flex-col gap-6 bg-cover bg-center bg-no-repeat rounded-xl items-start justify-end px-6 pb-12 md:px-12" data-alt="Abstract blue and white scientific background" style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.5) 100%), url(${top})`}}>
            <div class="flex flex-col gap-4 text-left max-w-3xl">
            <h1 class="text-white text-4xl font-black leading-tight tracking-tight @[480px]:text-5xl">Building a community for a Healthier and happier Tomorrow</h1>
            <p class="text-white text-base font-normal leading-normal @[480px]:text-lg">Using innovative therapies to improve patient lives worldwide.</p>
            </div>
            <button onClick={up} class="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-12 px-5 bg-accent text-white text-base font-bold leading-normal tracking-[0.015em] hover:bg-opacity-90">
            <span class="truncate">Explore Our Mission</span>
            </button>
            </div>
            </div>
            </section>
          

            <section class="bg-secondary dark:bg-background-dark py-16 sm:py-24">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="text-center mb-12">
            <h2 class="text-3xl font-bold tracking-tight text-heading-primary dark:text-white sm:text-4xl">Our Focus</h2>
            <p class="mt-4 text-lg text-text-primary dark:text-gray-300">Driving innovation in key areas to address unmet medical needs.</p>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <div class="flex flex-col gap-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-background-light dark:bg-gray-800 p-6 text-center items-center">
            <div class="text-primary bg-primary/10 rounded-full p-3">
            <span class="material-symbols-outlined text-3xl">science</span>
            </div>
            <div class="flex flex-col gap-1">
            <h3 class="text-lg font-bold text-heading-primary dark:text-white">Offering wholesome supplement</h3>
            <p class="text-text-primary dark:text-gray-300 text-sm leading-normal">Our commitment in discovering your bodies vital needs</p>
            </div>
            </div>
            <div class="flex flex-col gap-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-background-light dark:bg-gray-800 p-6 text-center items-center">
            <div class="text-primary bg-primary/10 rounded-full p-3">
            <span class="material-symbols-outlined text-3xl">favorite</span>
            </div>
            <div class="flex flex-col gap-1">
            <h3 class="text-lg font-bold text-heading-primary dark:text-white">Patient-Centric Care</h3>
            <p class="text-text-primary dark:text-gray-300 text-sm leading-normal">Putting patients at the heart of everything we do</p>
            </div>
            </div>
            <div class="flex flex-col gap-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-background-light dark:bg-gray-800 p-6 text-center items-center">
            <div class="text-primary bg-primary/10 rounded-full p-3">
            <span class="material-symbols-outlined text-3xl">medication</span>
            </div>
            <div class="flex flex-col gap-1">
            <h3 class="text-lg font-bold text-heading-primary dark:text-white">Featured Therapies</h3>
            <p class="text-text-primary dark:text-gray-300 text-sm leading-normal">Learn about our leading treatments that are making a difference in people's lives.</p>
            </div>
            </div>
            </div>
            </div>
            </section>
          

            <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
            <div class="w-full bg-center bg-no-repeat aspect-video bg-cover rounded-xl" data-alt="A professional, diverse team of scientists in a modern laboratory" style={{backgroundImage: `url(${doc})`}}></div>
            </div>
            <div class="flex flex-col gap-4">
            <h2 class="text-3xl font-bold tracking-tight text-heading-primary dark:text-white sm:text-4xl">Our Commitment to Patients</h2>
            <p class="text-text-primary dark:text-gray-300">Founded with a vision to tackle the life treating diseases, we combine cutting-edge science with a deep-seated commitment to our values and the global community. We are driven by the needs of patients, striving to deliver medicines that offer significant improvements over existing treatments. Our history is built on a foundation of integrity and a relentless pursuit of excellence.</p>
            <div class="mt-4">
            <a class="text-primary font-bold hover:underline" href="#">Learn More About Us</a>
            </div>
            </div>
            </div>
            </section>
           
            <section class="bg-secondary dark:bg-background-dark py-16 sm:py-24">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="text-center mb-12">
            <h2 class="text-3xl font-bold tracking-tight text-heading-primary dark:text-white sm:text-4xl">Latest News &amp; Updates</h2>
            <p class="mt-4 text-lg text-text-primary dark:text-gray-300">Stay informed about our latest research, milestones, and community involvement.</p>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div class="flex flex-col bg-background-light dark:bg-gray-800 rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700">
            <div class="w-full bg-center bg-no-repeat aspect-video bg-cover" data-alt="A scientist looking through a microscope" style={{backgroundImage: `url(${r1})`}}></div>
            <div class="p-6 flex flex-col flex-grow">
            <p class="text-sm text-gray-500 dark:text-gray-400">PRESS RELEASE - OCT 26, 2022</p>
            <h3 class="text-lg font-bold mt-2 text-heading-primary dark:text-white">ABJ pharmaceuticals Announces Positive Phase 3 Trial Results</h3>
            <p class="mt-2 text-sm text-text-primary dark:text-gray-300 flex-grow">The study met its primary endpoints, demonstrating significant efficacy and a favorable safety profile...</p>
            <a class="text-primary font-bold mt-4 self-start hover:underline" href="#">Read More</a>
            </div>
            </div>
            <div class="flex flex-col bg-background-light dark:bg-gray-800 rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700">
            <div class="w-full bg-center bg-no-repeat aspect-video bg-cover" data-alt="Close-up of laboratory glassware" style={{backgroundImage: `url(${p2})`}}></div>
            <div class="p-6 flex flex-col flex-grow">
            <p class="text-sm text-gray-500 dark:text-gray-400">IN THE NEWS - OCT 15, 2022</p>
            <h3 class="text-lg font-bold mt-2 text-heading-primary dark:text-white">Kicking off our new all in one supplement</h3>
            <p class="mt-2 text-sm text-text-primary dark:text-gray-300 flex-grow">Family wellness package for the everyone.</p>
            <a class="text-primary font-bold mt-4 self-start hover:underline" href="#">Read More</a>
            </div>
            </div>
            <div class="flex flex-col bg-background-light dark:bg-gray-800 rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700">
            <div class="w-full bg-center bg-no-repeat aspect-video bg-cover" data-alt="A healthcare professional consulting with a patient" style={{backgroundImage: `url(${p3})`}}></div>
            <div class="p-6 flex flex-col flex-grow">
            <p class="text-sm text-gray-500 dark:text-gray-400">COMMUNITY - SEP 28, 2023</p>
            <h3 class="text-lg font-bold mt-2 text-heading-primary dark:text-white">Partnering with Patient Advocacy Groups</h3>
            <p class="mt-2 text-sm text-text-primary dark:text-gray-300 flex-grow">We are proud to collaborate to raise awareness and support for patient communities.</p>
            <a class="text-primary font-bold mt-4 self-start hover:underline" href="#">Read More</a>
            </div>
            </div>
            </div>
            </div>
        </section>

    </>
  )
}

export default Hero
